// extracted by mini-css-extract-plugin
export default {"root":"UploadArea_root__-rQhx","loaded":"UploadArea_loaded__6peuP","icon":"UploadArea_icon__NGVI2","text":"UploadArea_text__oyRMb","removeBtn":"UploadArea_removeBtn__ffpYl"};